/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBracketsAngle = createReactComponent("outline", "brackets-angle", "IconBracketsAngle", [["path", { "d": "M8 4l-5 8l5 8", "key": "svg-0" }], ["path", { "d": "M16 4l5 8l-5 8", "key": "svg-1" }]]);

export { IconBracketsAngle as default };
//# sourceMappingURL=IconBracketsAngle.mjs.map
